module.exports = __webpack_public_path__ + "img/npm.21107776.svg";